var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-input',{ref:"editor",attrs:{"type":"number","disabled":_vm.editor.disabled,"min":_vm.editor.min,"max":_vm.editor.max,"step":_vm.editor.step},on:{"change":_vm.onValueChanged,"blur":_vm.onBlur},model:{value:(_vm.getValue),callback:function ($$v) {_vm.getValue=$$v},expression:"getValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }